import { LoadingBar } from "@tutellus/tutellus-components"
import { useTranslation } from "react-i18next"
import { LOGO, LOGO_DARK } from "../../js/const/logos"
import { ThemeMode, useLayout } from "../../context"

export const Loading = () => {
  const { t } = useTranslation()
  const { themeMode } = useLayout()

  const logoSrc = themeMode === ThemeMode.DARK ? LOGO_DARK : LOGO

  return <LoadingBar mode={themeMode} isFullScreen icon={<img src={logoSrc} alt={t("common:cnkt-migrator")}></img>} />
}
